import { EPRCard } from "./components/EPRCard";
import EPRParagraphTextOnly from "./components/EPRParagraphBox/TextOnly";
import WithButtonsBox from "./components/EPRParagraphBox/WithButtons";
import DIYCard from "./components/EPRDoCard/DIYCard";
import WithHelpCard from "./components/EPRDoCard/WithHelpCard";
import "./index.css";
import { useContext, useState, useEffect } from "react";
import { AccountContext } from "../../../App";
import { getAccountingYears } from "../../../apis/E-conomic/AccountingEntriesByYearApi";
import EPRWorkflowTabs from "./EPRWorkflowTabs";
import { TabDependentCard } from "./components/EPRParagraphBox/TabDependentCard";
import { getEconomicSupplierListBulkByYear } from "../../../apis/Business/EconomicSupplierBulk";
import locked from "../../../assets/locked.svg";
import { useUserModules } from "../../../components/UserModuleContext";

const EPRBox = ({ businessId: businessIdProp }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const { account } = useContext(AccountContext);
  const { isModuleAccessible } = useUserModules();
  const [isPaid, setIsPaid] = useState(false);
  const [businessIdInternal, setBusinessIdInternal] = useState(null);
  const businessId = businessIdProp || businessIdInternal;
  const [accountingYears, setAccountingYears] = useState();
  const [chosenYear, setChosenYear] = useState();
  const [yearEcoAPI, setYearEcoApi] = useState();
  const [accountingPeriod, setAccountingPeriod] = useState("");
  const [allocatedYear, setAllocatedYear] = useState("");
  const [isFetchedSupplier, setIsFetchedSupplier] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isEdit, setIsEdfit] = useState(false);
  const [submittedData, setSubmittedData] = useState([]);

  // Check if ERP module is accessible
  const hasERPAccess = isModuleAccessible("ERP");

  useEffect(() => {
    if (account && account.profile && account.profile.account) {
      setIsPaid(!!account.profile.account.subscription);
    }
  }, [account]);

  useEffect(() => {
    getAccountingYears({ setAccountingYears: setAccountingYears });
  }, []);

  useEffect(() => {
    if (hasERPAccess && businessId) {
      getEconomicSupplierListBulkByYear({
        allocatedYear: year,
        businessId: businessId,
        setObjectsIsSelected: setSubmittedData,
        setChosenYear: setChosenYear,
        setYearEcoApi: setYearEcoApi,
        setAccountingPeriod: setAccountingPeriod,
        isEdit: isEdit,
      });
    }
  }, [businessId, year, isEdit, hasERPAccess]);

  useEffect(() => {
    if (submittedData?.length !== 0) {
      setIsEdfit(true);
    } else {
      setIsEdfit(false);
    }
  }, [setIsEdfit, submittedData]);

  return (
    <div
      className="epr-container"
      style={{ maxWidth: "100%", position: "relative" }}
    >
      {/* Lock overlay when ERP is not accessible */}
      {!hasERPAccess ? (
        <div
          style={{
            width: "100%",
            maxHeight: "fit-content",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 100,
            borderRadius: "8px",
          }}
        >
          <img
            src={locked}
            alt="Locked Feature"
            style={{
              width: "64px",
              height: "64px",
              marginBottom: "16px",
            }}
          />
          <div
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "center",
              maxWidth: "80%",
              color: "#193666",
            }}
          >
            ERP is only available with the Catalyst Bundle and beyond
          </div>
          <div
            style={{
              fontSize: "14px",
              marginTop: "8px",
              textAlign: "center",
              maxWidth: "80%",
              color: "#193666",
            }}
          >
            Upgrade your subscription to access this feature
          </div>
        </div>
      ) : (
        <>
          <div style={{ display: "flex" }}>
            <div>
              <EPRCard />
            </div>
            <div style={{ marginLeft: "26px", maxWidth: "80%" }}>
              {activeIndex === 0 ? (
                <WithButtonsBox
                  yearEcoApi={yearEcoAPI}
                  chosenYear={chosenYear}
                  setIsFetchedSupplier={setIsFetchedSupplier}
                  period={accountingPeriod}
                  allocatedYear={allocatedYear}
                />
              ) : (
                <TabDependentCard
                  accountingPeriod={accountingPeriod}
                  activeIndex={activeIndex}
                />
              )}
            </div>
          </div>
          <EPRWorkflowTabs
            businessId={businessId}
            setChosenYear={setChosenYear}
            setYearEcoApi={setYearEcoApi}
            chosenYear={chosenYear}
            yearEcoAPI={yearEcoAPI}
            accountingPeriod={accountingPeriod}
            setAccountingPeriod={setAccountingPeriod}
            allocatedYear={allocatedYear}
            setAllocatedYear={setAllocatedYear}
            setActiveIndex={setActiveIndex}
            submittedData={submittedData}
            isEdit={isEdit}
          />
        </>
      )}
    </div>
  );
};

export default EPRBox;
